import styled from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const PaginationWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    @media ${(props) => props.theme.query.min.tablet} {
        margin-top: 50px;
    }

    svg {
        margin: 0px 20px;
    }
`

export const Separator = styled.div`
    width: 2px;
    height: 40px;
    background: ${(props) => props.theme.color.a500};
    overflow: hidden;
    margin: 0px 20px;
`

export const Link = styled(LinkBase)`
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;

    &:hover {
        color: ${(props) => props.theme.color.g500};

        svg {
            path {
                stroke: ${(props) => props.theme.color.g500};
            }
        }
    }
`

export const Disabled = styled.div`
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.color.g300};

    svg {
        path {
            stroke: ${(props) => props.theme.color.g300};
        }
    }
`
